import moment from "moment";
import { ModalTopSection } from "../../../components/DetailsModal/ModalTopSection";
import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  SectionSubheader,
} from "../../../components";
import { ModalSectionTitle } from "../../../components";
import { LeftRightFlexedContainer } from "../../../components";
import { IBeneficiaryDetailsModalViewProps } from "./BankBeneficiaryDetailsModal";
import { appConfig } from "../../../configs";
import { countries, currencies } from "../../../constants";
import { SingleTransferNoBatchList } from "../../Transfers";
import { beneficiaryTypes } from "../../../enums";

export const View = (props: IBeneficiaryDetailsModalViewProps) => {
  const beneficiaryCountry = countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === props.modalData?.country) !==
        undefined
    )
    ?.options.find((ctry) => ctry.value === props.modalData?.country);

  // TODO: add a global context with supported countries and currencies
  // const currency = swAppSupportedCurrencies.find((cur) => cur.value === item.currency);
  const beneficiaryCurrency = currencies.find(
    (cur) => cur.value === props.modalData?.currency
  );

  const beneficiaryProperties = !props.modalData
    ? {}
    : props.modalData.beneficiary_type === beneficiaryTypes.bankAccount
    ? {
        // bank beneficiary
        account_number: props.modalData.account_number,
        account_name: props.modalData.account_name,
        bank_name: props.modalData.bank_name,
        bank_code: props.modalData.bank_code,
      }
    : {
        // gw beneficiary
      };

  return (
    <div className="beneficiary-details--container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="payment-modal-container"
        modalHeader={
          !props.modalData ? (
            <SectionSubheader title="BENEFICIARY DETAILS" />
          ) : (
            <ModalTopSection
              header="BENEFICIARY DETAILS"
              subHeader={
                <div className="name-sub-header flex-container align-items--end justify-content--start">
                  {props.modalData.email}
                </div>
              }
              copyText="Beneficiary ID"
              copyContent={props.modalData.id}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.modalData ? (
          <>
            {props.isLoadingModalData ? (
              <DataLoadingView message={"Loading beneficiary details"} />
            ) : (
              <ErrorOccuredView
                message={
                  "An error occured while loading the beneficiary details. Please retry..."
                }
              />
            )}
          </>
        ) : (
          <>
            <>
              <LeftRightFlexedContainer
                key_id="Alias/Nickname"
                value={props.modalData.full_name || "..."}
              />
              <LeftRightFlexedContainer
                key_id="Email"
                value={props.modalData.email}
              />
              {!props.modalData.phone_number ? null : (
                <LeftRightFlexedContainer
                  key_id="Phone Number"
                  value={props.modalData.phone_number}
                />
              )}
              <LeftRightFlexedContainer
                key_id="Date Added"
                value={moment(props.modalData.created_at).format(
                  appConfig.dateTimeFormat
                )}
              />

              {
                <LeftRightFlexedContainer
                  key_id="Country"
                  value={beneficiaryCountry?.text ?? props.modalData.country}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Currency"
                  value={beneficiaryCurrency?.text ?? props.modalData.currency}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Bank Name"
                  value={props.modalData.bank_name}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Account Name"
                  value={props.modalData.account_name}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Account Number"
                  value={props.modalData.account_number}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Description"
                  value={props.modalData.description || "..."}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Beneficiary Type"
                  value={"BANK ACCOUNT"}
                />
              }
            </>

            <>
              <ModalSectionTitle key_id="Transfers History" value="" />
              <SingleTransferNoBatchList
                queryFilters={{
                  country: props.modalData.country,
                  currency: props.modalData.currency,
                  bankTransferFilter:
                    props.modalData.beneficiary_type ===
                    beneficiaryTypes.bankAccount
                      ? {
                          account_number: props.modalData.account_number,
                          bank_code: props.modalData.bank_code,
                          // account_name: props.modalData.account_name,
                          // bank_name: props.modalData.bank_name,
                        }
                      : {},
                }}
              />
            </>
          </>
        )}
      </ModalContainer>
    </div>
  );
};
